export class MissionAssetTransformer {
  static transform(obj) {
    return {
      id: obj.id,
      missionId: obj.attributes.mission_id,
      coreId: obj.attributes.core_id,
      thirdPartyCode: obj.attributes.third_party_code,
      qa: obj.attributes.q_and_a,
      // isCleaned: obj.attributes.is_cleaned,
      isFault: obj.attributes.is_fault,
      faults_resolved_at: obj.attributes.faults_resolved_at,
      faults: obj.attributes.faults,
      passFail: obj.attributes.pass_fail,
      newAsset: obj.attributes.new_asset,
      createdAt: obj.attributes.created_at,
      updatedAt: obj.attributes.updated_at,
      createdBy: obj.attributes.created_by,
    };
  }
}
